jQuery(function () {
  // Allow showing and hiding of sidebar

  var pageHeaderRadios = jQuery(".page-header-tabs .tab-selector-radio");
  var contentPreviewContainer = jQuery("[data-behaviour~=content-preview]");

  var sidebarContainer = jQuery(".sidebar");
  var sidebarContent = jQuery(".sidebar-content", sidebarContainer);

  var pageBuilderTab = jQuery("#tab_page_builder");
  const layoutBuilderTab = jQuery("#tab_layout_builder");

  var componentsTab = jQuery("#tab_components");
  const layoutBuilderTabSidebar = jQuery("#tab_layout_builder_sidebar");
  var infoTab = jQuery("#tab_info");

  function setToggleIcon(name) {
    sidebarContainer[0]?.querySelector(".sidebar-toggle-menu-item")?.setAttribute("icon", name);
  }

  function toggleShowSidebar(isShowing) {
    if (isShowing && !sidebarContainer.hasClass("showing")) {
      sidebarContainer.addClass("showing");
      sidebarContainer.removeClass("--no-highlight --is-hidden");

      setToggleIcon("sidebar-collapse");

      sidebarContent.one("transitionend", function () {
        contentPreviewContainer.addClass("showing");
      });
    } else if (!isShowing && sidebarContainer.hasClass("showing")) {
      contentPreviewContainer.removeClass("showing");
      sidebarContainer.removeClass("showing");
      sidebarContainer.addClass("--no-highlight");

      setToggleIcon("sidebar-expand");

      sidebarContent.one("transitionend", function () {
        sidebarContainer.addClass("--is-hidden");
      });
    }
  }

  function configureSidebarTabs() {
    const componentsTabSelector = componentsTab.closest(".tab-selector");
    componentsTabSelector.toggle(pageBuilderTab.is(":checked"));
    componentsTab.prop("disabled", !pageBuilderTab.is(":checked"));

    const layoutBuilderTabSelector = layoutBuilderTabSidebar.closest(".tab-selector");
    layoutBuilderTabSelector.toggle(layoutBuilderTab.is(":checked"));

    if (componentsTab.is(":checked") && componentsTab.is(":disabled")) {
      componentsTabSelector.data("checked", true);
      infoTab.trigger("click");
    } else if (componentsTabSelector.data("checked")) {
      componentsTab.trigger("click");
      componentsTabSelector.data("checked", false);
    }

    if (layoutBuilderTab.is(":checked")) {
      layoutBuilderTabSidebar.trigger("click");
    }
  }

  pageHeaderRadios.on("click", function () {
    configureSidebarTabs();

    if (jQuery(this).val() == "tab_reports") {
      toggleShowSidebar(false);
    } else {
      toggleShowSidebar(true);
    }
  });
  configureSidebarTabs();

  const sidebarElement = document.querySelector(".sidebar");
  const sidebarTabRadios = sidebarElement?.querySelectorAll(".sidebar-menu .tab-selector-radio") ?? [];

  function markCheckedTabSelected() {
    sidebarTabRadios.forEach((radio) => {
      radio.closest(".tab-selector").classList.toggle("--selected", radio.checked);
    });
  }

  // A click runs before the radio's change event, so `--selected` still marks the previously checked tab here.
  function toggleSidebarFromTab(event) {
    const isSelectedTab = event.currentTarget.closest(".tab-selector").classList.contains("--selected");

    toggleShowSidebar(!(isSelectedTab && sidebarElement.classList.contains("showing")));
  }

  sidebarTabRadios.forEach((radio) => {
    radio.addEventListener("click", toggleSidebarFromTab);
    // `Sparkle.Tabs.selectTab` checks a tab without clicking its radio, so the highlight follows the change event.
    radio.addEventListener("change", markCheckedTabSelected);
  });
  markCheckedTabSelected();

  sidebarContainer.on("click", '[data-behaviour="toggle-sidebar"]', function () {
    toggleShowSidebar(!sidebarContainer.hasClass("showing"));
  });

  // Switch to components tab when page builder is engaged
  if (Sparkle.PageBuilder?.Helpers?.Event) {
    Sparkle.PageBuilder.Helpers.Event.on("pb:sidebar:show", function () {
      if (componentsTab.is(":checked")) {
        return;
      }

      componentsTab.trigger("click");
    });
  }
});
